import map from 'lodash/map';
import find from 'lodash/find';
import filter from 'lodash/filter';
import values from 'lodash/values';
import includes from 'lodash/includes';


// https://docs.aws.amazon.com/translate/latest/dg/what-is-languages.html
import RTL_LANGUAGES from './rtl_languages.json';
import AVAILABLE_LANGUAGES from './available_languages.json';


export const DEFAULT_LANGUAGE_ISO = 'en';

export const VALID_LANGUAGE_ISO_CODES = values(AVAILABLE_LANGUAGES);

export const getIsRtlLanguage = (iso)=> (
  includes(values(RTL_LANGUAGES), iso)
);

export const AVAILABLE_LANGUAGE_OPTIONS = filter(map(AVAILABLE_LANGUAGES, (iso_code, language_str)=> {
  return {
    label: language_str,
    value: iso_code
  };
}), (lang)=> {
  return !getIsRtlLanguage(lang.value);
});

export const getLanguageLabelForIso = (iso)=> {
  const lang = find(AVAILABLE_LANGUAGE_OPTIONS, ['value', iso]);

  return lang ? lang.label : null;
};
